import { getType } from 'typesafe-actions';
import { IStore } from '../../store';
import { jobSelectors } from '../../_core/job';
import { IAnnex6Store } from './@types';
import annex6Actions, { EAnnex6Actions } from './actions';

const annex6Selectors = {
    _getStore(store: IStore) {
        return store.app.annex6;
    },
    getHistoryList(store: IAnnex6Store) {
        return store.records.ids.map((id) => ({
            ...store.records.byIds[id],
        }));
    },
    getFilter(store: IAnnex6Store) {
        return {
            ...store.filter,
            shownRecords: store.filter.shownRecords
                ? store.filter.shownRecords
                : 'ALL',
        };
    },
    jobToLoadHistory(store: IAnnex6Store) {
        return jobSelectors.getJobStatus(store, EAnnex6Actions.HISTORY_LOAD);
    },
};
export default annex6Selectors;
